import api from './api';
import type { FinanceOrderBasis } from './finance-source-api';
export interface FinanceParcelSpan { lineRef: string; unitFrom: number; unitThrough: number }
export interface FinanceParcelInput { shipmentId: string; role: 'ORIGINAL'|'REPLACEMENT'|'RETURN'; relatedShipmentId: string|null; lines: FinanceParcelSpan[] }
export interface FinanceParcelShipment { shipmentId: string; carrier: string; shipmentUpdatedAt: string }
export interface FinanceParcelDeclaration {
  manifest: { id:string;tenantId:string;storeId:string;orderId:string;sourceRevisionId:string;basisHash:string;ordinal:number;recordedAt:string };
  body: { sourceRevisionId:string;basisHash:string;evidenceRef:string;parcels:Array<FinanceParcelInput & FinanceParcelShipment> };
  quantities:Array<{lineRef:string;ordered:number;declaredOriginal:number;unassigned:number}>;
  quality:'ADMIN_DECLARED_CONTENTS'; receiptConfirmed:false; commerceCoverage:'UNAVAILABLE';
}
export interface FinanceParcelContext {
  tenantId:string;storeId:string;orderId:string;
  basis:{sourceRevisionId:string;recordedAt:string;basisHash:string;source:Extract<FinanceOrderBasis,{status:'READ'}>['basis']}|null;
  shipments:FinanceParcelShipment[];previous:FinanceParcelDeclaration|null;
}
export interface FinanceParcelWrite {
  storeId:string;sourceRevisionId:string;basisHash:string;evidenceRef:string;acquisitionKey:string;previousManifestId:string|null;
  expectedShipments:FinanceParcelShipment[];parcels:FinanceParcelInput[];
}
export const financeParcelApi={
  context:(storeId:string,orderId:string)=>api.get<FinanceParcelContext>(`/finance/orders/${encodeURIComponent(orderId)}/parcel-manifest-context`,{params:{storeId}}),
  history:(storeId:string,orderId:string,knowledgeAsOf?:string)=>api.get<{storeId:string;orderId:string;knowledgeAsOf:string;current:FinanceParcelDeclaration|null}>(
    `/finance/orders/${encodeURIComponent(orderId)}/parcel-manifests`,{params:{storeId,knowledgeAsOf}}),
  write:(orderId:string,body:FinanceParcelWrite)=>api.post<FinanceParcelDeclaration & {replayed:boolean}>(
    `/finance/orders/${encodeURIComponent(orderId)}/parcel-manifests`,body),
};
